module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows@2x-9d8d8bb2f85b727e8bf443791d79030c.png";